"use client";

import classNames from "@/helpers/classNames";
import type { StallContext } from "@/tools/medusa";
import styles from "./styles.module.scss";

interface StallContextBannerProps {
  stallContext: StallContext;
  onClear: () => void;
  className?: string;
}

const StallContextBanner = ({ stallContext, onClear, className }: StallContextBannerProps) => (
  <p className={classNames(styles.banner, className)} role="status" aria-live="polite">
    Your order supports <span className={styles.stallName}>{stallContext.stallName}</span>
    {". "}
    <button
      type="button"
      className={styles.clearButton}
      onClick={onClear}
      aria-label={`Stop supporting ${stallContext.stallName}`}
    >
      Shop without a stall
    </button>
  </p>
);

export default StallContextBanner;
export type { StallContextBannerProps };
